import Stack from "@mui/material/Stack";
import type { ReactElement } from "react";
import { CardsSection } from "../../components/CardsSection";
import solutionsData from "../../data/pages/solutions.json";
import type { SolutionsPageTemplate } from "../../types/solutionsPageTemplate";
import { resolveAssetUrl } from "../../utils/resolveAssetUrl";

const typedSolutionsData = solutionsData as SolutionsPageTemplate;

export default function SolutionsPage(): ReactElement {
  return (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
        flexDirection: "column",
        alignItems: "center",
        pt: "50px",
        px: { sm: 0, md: "40px" },
        pb: "48px",
      }}
    >
      <CardsSection
        cards={typedSolutionsData.solutions.map((solution) => ({
          title: solution.solution,
          body: solution.title,
          image: {
            src: resolveAssetUrl(solution.img),
            alt: solution.imgAlt,
          },
          links: [{ label: "Learn more", href: solution.href, type: "button" }],
        }))}
        cardsPerRow={{ md: 2, lg: 2 }}
        cardStyle={{ padding: 4, minHeight: "280px" }}
      />
    </Stack>
  );
}
